// extracted by mini-css-extract-plugin
export var progressBar = "_l2-0";
export var progressBarInner = "_l2-1";